import React from 'react';

const Copyright = () => {
    return (
        <div className="copyright">
            <p style={{ fontFamily: 'Encode' }}>© 2023 The Shappire Studio | Sheana Marie Artistry LLC</p>
        </div>
    );
};

export default Copyright;
